export default "__VITE_ASSET__CPWWwcCC__"